<template>
  <Common>
    <template #transport>
      <h2>{{$t('track.trackWay.ukraine.h2')}}</h2>
    </template>

    <template #list>
      <p>{{$t('track.trackWay.ukraine.list.p1')}}</p>
      <p>{{$t('track.trackWay.ukraine.list.p2')}}</p>
      <p>{{$t('track.trackWay.ukraine.list.p3')}}</p>
      <p>{{$t('track.trackWay.ukraine.list.p4')}}</p>
    </template>

    <!-- <template #pay>
      <h3>{{$t('track.trackWay.ukraine.pay.h3')}}</h3>
      <p>
        {{$t('track.trackWay.ukraine.pay.p1')}}<br />
        {{$t('track.trackWay.ukraine.pay.p2')}}
      </p>
    </template> -->
  </Common>
</template>

<script>
import Common from "@/views/track/components/Common";
export default {
  components: { Common },
};
</script>

<style>
</style>